module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_irouchikake-425f9235ec0231a233758a4514174d4e.jpg";